import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInfo: sessionStorage.getItem("userInfo")
    ? JSON.parse(sessionStorage.getItem("userInfo"))
    : null  
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.userInfo = action.payload;
      sessionStorage.setItem("userInfo", JSON.stringify(action.payload));
    },
    signOutApiCall: (state, action) => {
      state.userInfo = null;
      sessionStorage.removeItem("userInfo");
      sessionStorage.removeItem("isMaidenChecked")
    }
  },
});

export const { setCredentials, signOutApiCall} = authSlice.actions;

export default authSlice.reducer;
